<template lang="pug">
  b-container
    b-form-row.align-items-center.justify-content-between.mt-3.mb-4
      b-col
        b-button(variant="light", @click="goBack")
          arrow-left-icon.icon-md.mr-2
          span Regresar a productos
    b-form-row.align-items-center.justify-content-between.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 {{ $route.params.product_id !== 'new' ? 'Editar' : 'Nuevo'}} Producto

    validation-observer(ref="person_observer", v-slot="{ invalid, handleSubmit, errors }")
      b-form(@submit.prevent="handleSubmit(updateProduct)")
        input(type="file", accept="image/*", ref="new_image_input", style="display:none;", @change="newImagePicked($event)")
        b-row
          b-col.mb-3(cols="12")
            .d-flex.align-items-start
              div(style="flex:0 0 250px;")
                .image-container(style="width:250px;flex:0 0 auto;position:relative;")
                  b-form-group.mb-2
                    b-img.pointer(width="250", height="250", :blank="!product.image", blank-color="#f2f2f2", rounded, :src="product.image", @click="$refs.upload_image_input.click()", style="object-fit:cover;")
                  camera-icon.center-in-container(style="width:50px;height:50px;pointer-events:none;color:#ddd;", v-if="!product.image")
                  b-form-row.justify-content-center
                    input(type="file", accept="image/*", ref="upload_image_input", style="display:none;", @change="imagePicked($event)")
                    b-col.text-center
                      b-link(@click="$refs.upload_image_input.click()") {{ product.image ? 'Cambiar imagen' : 'Subir imagen' }}
                    b-col.text-center(v-if="product.image")
                      b-link.text-danger(@click="clearImage") Quitar imagen

              div.scrollable-area.d-none.d-md-block(style="overflow-x:scroll;white-space:nowrap;flex-wrap:nowrap;margin-left:25px;padding-bottom:15px;")
                .d-flex.align-items-start.justify-content-start
                  .mx-3.text-center.d-flex.align-items-center.justify-content-center.flex-column(v-for="image in images" :key="image.image_id" style="flex:0 0 auto;")
                    b-img.mb-2(width="150" height="150" :src="image.url" :blank="!image.url" @error="image.url = null" rounded style="object-fit:cover;")
                    b-link.text-sm.text-danger(@click="deleteImage(image)") Eliminar imagen
                  .add-image-button.d-flex.align-items-center.justify-content-center.flex-column.mx-3.pointer(@click="$refs['new_image_input'].click()" style="flex:0 0 auto;" v-if="$route.params.product_id !== 'new'")
                    plus-icon.mb-3
                    span Agregar imágen
                  p.text-secondary(v-else) Podrás agregar más imágenes después de crear el producto

            .d-flex.align-items-start.justify-content-start.d-md-none.mt-3.scrollable-area(style="overflow-x:scroll;white-space:nowrap;padding-bottom:15px;")
              .mx-3.text-center.d-flex.align-items-center.justify-content-center.flex-column(v-for="image in images" :key="image.image_id" style="flex:0 0 auto;")
                b-img.mb-2(width="150" height="150" :src="image.url" :blank="!image.url" @error="image.url = null" rounded style="object-fit:cover;")
                b-link.text-sm.text-danger(@click="deleteImage(image)") Eliminar imagen
              .add-image-button.d-flex.align-items-center.justify-content-center.flex-column.mx-3.pointer(@click="$refs['new_image_input'].click()" style="flex:0 0 auto;" v-if="$route.params.product_id !== 'new'")
                plus-icon.mb-3
                span Agregar imágen
              p.text-secondary(v-else) Podrás agregar más imágenes después de crear el producto

          b-col.mb-3(md="6")
            validation-provider(rules="required", name="nombre de producto", v-slot="{ valid, errors, validated, dirty }")
              b-form-group(label="Nombre de producto", description="Escribe un nombre corto y claro para el producto")
                b-form-input(placeholder="Nombre de producto", v-model="product.name" :state="!valid && validated ? false : null")
                b-form-invalid-feedback {{ errors[0] }}
          b-col.mb-3(md="6")
            validation-provider(rules="required|numeric|max:10|min_value:0", name="stock", v-slot="{ valid, errors, validated, dirty }")
              b-form-group(label="Stock disponible", description="Si no hay disponibilidad de stock se deshabilitará el producto. Si el producto tiene variables se considera el stock de éstas..")
                b-form-input(placeholder="Cantidad disponible", type="number", v-model="product.stock" min="0" :state="!valid && validated ? false : null")
                b-form-invalid-feedback {{ errors[0] }}
          b-col.mb-3(md="6")
            validation-provider(:rules="{required:true, max:15, regex: /^[0-9\.\,]+$/}", name="precio", v-slot="{ valid, errors, validated, dirty }")
              b-form-group(label="Precio", description="Si el producto posee variantes, se tomarán en cuenta sus precios.")
                b-input-group(prepend="$")
                  b-form-input(placeholder="Precio", :value="parsedPrice", @input="product.price = parseFloat($event.replace(/,/g,''))", @keypress="numbersOnly", :state="!valid && validated ? false : null")
                  b-form-invalid-feedback {{ errors[0] }}
          b-col.mb-3(md="6")
            validation-provider(rules="required", name="precio", v-slot="{ valid, errors, validated, dirty }")
              b-form-group(label="Detalles de precio", description="Descripción de pagos diferidos")
                b-form-input(placeholder="Detalles de precio", v-model="product.price_details", :state="!valid && validated ? false : null")
                b-form-invalid-feedback {{ errors[0] }}
          b-col.mb-3(cols="12")
            b-form-group(label="Descripción del producto")
              b-form-textarea(placeholder="Descripción del producto", no-resize, rows="2", max-rows="5", v-model="product.description")

          b-col.mb-3(cols="12", v-if="$route.name != 'Service'")
            b-form-group(label="Categorías")
              b-button.m-1(v-for="cat in categories_list", :key="cat.value", pill, :variant="current_categories.includes(cat.value) ? 'primary' : 'outline-secondary'", @click="changeCategories(cat.value)", :disabled="loading_categories")
                .d-flex.align-items-center
                  span.mr-1 {{cat.text}}
                  check-icon.icon-sm(v-if="current_categories.includes(cat.value)")
              div.mt-2
                b-button.m-1(v-for="cat in AllCategories", :key="cat.value.category_id", pill, :variant="current_categories.includes(cat.value.category_id) ? 'primary' : 'outline-secondary'", @click="changeCategories(cat.value.category_id)", :disabled="loading_categories")
                  .d-flex.align-items-center.justify-content-start.text-left.px-2
                    div.d-flex.flex-column.align-items-start
                      span.text-help.mr-3(style="font-size:12px;") de {{ getCategoryName(cat.value.parent_category_id) }}
                      span.mr-3 {{cat.text}}
                    check-icon.icon-sm(v-if="current_categories.includes(cat.value.category_id)")
              div.mt-2
                b-link.text-sm(:to="{name: 'Products Categories'}", target="_blank") Crear más categorías
                  external-link-icon.icon-sm.ml-2

          b-col.mb-3(md="6", v-if="isUpdate")
            b-card.bg-light.no-shadow.mb-0.h-100
              p.mb-1 Estado del producto
              p.text-secondary Esta opción te permite pausar la venta del producto.
              b-form-group
                b-form-checkbox(switch, v-model="product.enabled")
                  span(:class="{'text-danger': !product.enabled}") {{ product.enabled ? 'A la venta' : 'Venta pausada' }}
          b-col.mb-3(md="6", v-if="isUpdate")
            b-card.bg-light.no-shadow.mb-0.h-100
              p.mb-1 Ocultar producto
              p.text-secondary Esta opción te permite ocultar el producto de la galería en el chat para restringir su venta solo con el link directo.
              b-form-group(description="Si está oculto tus clientes aún pueden acceder a él con el link directo.")
                b-form-checkbox(switch, v-model="product.hide")
                  span(:class="{'text-danger': product.hide}") {{ product.hide ? 'Oculto en galería' : 'Producto visible para todos' }}

          //b-col(cols="12")
            b-card.no-shadow.bg-light
              b-row.align-items-center.pointer(v-b-toggle.variants-collapse)
                b-col
                  h5.mb-2 Variantes de producto
                  p.mb-0.text-secondary Esta opción te permitirá agregar características específicas de tu producto, por ejemplo: tallas, colores, etc.
                b-col(cols="auto")
                  chevron-down-icon
              b-collapse(id="variants-collapse" :visible="!isNaN($route.params.product_id)")
                div(v-if="!isNaN($route.params.product_id)")
                  b-form-row.my-3
                    b-col.text-right
                      b-button(variant="primary", size="sm" @click="createVariant", :disabled="loading")
                        span(v-if="!loading") Crear nueva variante
                        b-spinner(variant="light", small, v-else, type="grow")
                  b-card.no-shadow.bg-white
                    variant-values(v-for="(variant, index) in parsed_variants", :key="index + parsed_variants.length", :variant="variant")
                  product-variants
                div(v-else)
                  b-alert.mb-0.mt-3(show variant="info")
                    b-form-row
                      b-col(cols="auto")
                        alert-triangle-icon
                      b-col
                        span Puedes crear variantes hasta después de guardar por primera vez el producto.

          b-col(cols="12")
            b-alert(show, variant="warning")
              b-form-row
                b-col(cols="auto")
                  alert-triangle-icon
                b-col
                  p.mb-0 Si quieres utilizar envíos a través de Envíos Kanguro es indispensable llenar los campos de peso y medidas en la siguiente sección.
                    b-link.text-primary.text-underline.text-sm.ml-1(@click="kanguroModal = true;") Más información sobre Envíos Kanguro.

          b-col(cols="12", v-if="$route.name != 'Service'")
            b-card.no-shadow.bg-light
              b-row.align-items-center.pointer(v-b-toggle.advanced-config)
                b-col
                  h5.mb-2 Más opciones de producto
                  p.mb-0.text-secondary Peso, tamaño, SKU, IDs y palabras clave.
                b-col(cols="auto")
                  chevron-down-icon
              b-collapse(id="advanced-config", :visible="measures_requiered")
                b-row.mt-3
                  b-col.mb-3(cols="12")
                    b-form-group(label="Palabras clave", description="Las palabras clave ayudan al Chatbot a encontrar los productos por palabras clave.")
                      b-form-tags(:value="product.keywords ? product.keywords.split(',') : []", @input="product.keywords = $event.join(',')", placeholder="Escribe las palabras clave separadas por coma", remove-on-delete, tag-variant="primary", add-button-text="Agregar", duplicate-tag-text="Etiquetas duplicadas", separator=" ,")
                  b-col.mb-3(md="6")
                    b-form-group(label="ID externo")
                      b-form-input(v-model="product.external_id", placeholder="ID externo")
                  b-col.mb-3(md="6")
                    b-form-group(label="SKU")
                      b-form-input(v-model="product.sku", placeholder="sku")
                  b-col.mb-3(md="6")
                    validation-provider(:rules="{required: measures_requiered, max:10, regex: /^[0-9\.]+$/}", name="peso", v-slot="{ valid, errors, validated, dirty }")
                      b-form-group(label="Peso", description="Solo números enteros")
                        b-input-group
                          b-form-input(type="number", v-model="product.weight", placeholder="0", min="0", step="1", :state="!valid && validated ? false : null")
                          b-input-group-append
                            b-input-group-text g
                          b-form-invalid-feedback {{ errors[0] }}
                  b-col.mb-3(md="6")
                    validation-provider(:rules="{required: measures_requiered, max:10, regex: /^[0-9\.]+$/}", name="largo", v-slot="{ valid, errors, validated, dirty }")
                      b-form-group(label="Largo")
                        b-input-group
                          b-form-input(type="number", v-model="product.length", placeholder="0.00", min="0", step="0.1", :state="!valid && validated ? false : null")
                          b-input-group-append
                            b-input-group-text cm
                          b-form-invalid-feedback {{ errors[0] }}
                  b-col.mb-3(md="6")
                    validation-provider(:rules="{required: measures_requiered, max:10, regex: /^[0-9\.]+$/}", name="ancho", v-slot="{ valid, errors, validated, dirty }")
                      b-form-group(label="Ancho")
                        b-input-group
                          b-form-input(type="number", v-model="product.width", placeholder="0.00", min="0", step="0.1", :state="!valid && validated ? false : null")
                          b-input-group-append
                            b-input-group-text cm
                          b-form-invalid-feedback {{ errors[0] }}
                  b-col.mb-3(md="6")
                    validation-provider(:rules="{required: measures_requiered, max:10, regex: /^[0-9\.]+$/}", name="alto", v-slot="{ valid, errors, validated, dirty }")
                      b-form-group(label="Alto")
                        b-input-group
                          b-form-input(type="number", v-model="product.height", placeholder="0.00", min="0", step="0.1", :state="!valid && validated ? false : null")
                          b-input-group-append
                            b-input-group-text cm
                          b-form-invalid-feedback {{ errors[0] }}
                  b-col.mb-3(cols="12")
                    b-form-group(label="Prioridad", description="Entre más alto sea el número de prioridad, se mostrará primero.")
                      b-form-select(v-model="product.priority")
                        option(value="") Sin prioridad
                        option(value="0") 0
                        option(v-for="n in 100", :value="n") {{ n }}
          b-col.mb-3.text-right(cols="12", v-if="product.product_id")
            b-button.text-danger(variant="link", @click="confirmDeleteProduct") Eliminar producto
          b-col(cols="12", style="margin-bottom:80px;")
            .mb-3
              p.text-center.text-danger.mb-1(v-for="error in errors" v-if="error[0]")
                alert-circle-icon.icon-sm.mr-2
                span {{ error[0] }}
            b-button.mb-3(variant="primary", block, size="lg", type="submit") Guardar producto
    b-modal(v-model="kanguroModal", title="Acerca de Envíos Kanguro", @ok="$router.push({name: 'Delivery'}).catch(() => {})", ok-only, ok-title="Configurar tipo de envío", ok-variant="primary")
      kanguro-info
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { UploadFile } from '@/helpers/upload-file'
import { toBase64 } from '@/helpers/file-converter'
import VariantValues from '@/components/VariantValues'
import ProductVariants from '@/components/ProductVariants'
import KanguroInfo from '@/components/KanguroInfo.vue'
import Validators from '@/helpers/data_validators'

const categoryController = createNamespacedHelpers('category')
const productController = createNamespacedHelpers('product')
const accountController = createNamespacedHelpers('account')
const variantController = createNamespacedHelpers('variant')
const ecommerceController = createNamespacedHelpers('delivery')

export default {
  mixins: [Validators.Methods],
  data() {
    return {
      loading: false,
      loading_categories: false,
      file: null,
      product: {
        product_id: null,
        name: '',
        description: '',
        image: '',
        price: '',
        stock: 0,
        enabled: true,
        priority: 0,
        keywords: '',
        categories: [],
        external_id: '',
        sku: '',
        weight: '',
        length: '',
        width: '',
        height: '',
        hide: false,
        validated: false
      },
      pending_categories: [],
      loading_product: false,
      kanguroModal: false,
      allCategories: [],
      variantsOpened: false,
      images: [],
      image: null
    };
  },
  computed: {
    ...categoryController.mapState({
      categories: state => state.categories
    }),
    ...variantController.mapState({
      variants: state => state.variants
    }),
    ...productController.mapState({
      all_products: state => state.all_products
    }),
    ...accountController.mapState({
      account: state => state.account
    }),
    ...ecommerceController.mapState({
      ecommerce_data: state => state.ecommerce_data
    }),
    isUpdate () {
      return Boolean(this.product.product_id)
    },
    categories_list () {
      return this.categories.map(c => {
        return {
          text: c.name,
          value: c.category_id
        }
      })
    },
    isPriceOk () {
      return Boolean(this.product.price) && !isNaN(this.product.stock) && parseFloat(this.product.price) >= 0
    },
    isStockPos () {
      return Boolean(this.product.stock) && !isNaN(this.product.stock) && this.product.stock >= 0
    },
    current_categories () {
      return this.product.product_id ? this.product.categories : this.pending_categories
    },
    measures_requiered () {
      return this.ecommerce_data.delivery_type_id == 2
    },
    parsed_variants () {
      return this.variants.map(p => {return p})
    },
    AllCategories () {
      return this.allCategories.filter(c => {
        return c.parent_category_id && (this.current_categories.includes(c.parent_category_id) || this.current_categories.includes(c.category_id))
      }).map(c => {
        return {
          text: c.name,
          value: {
            category_id: c.category_id,
            parent_category_id: c.parent_category_id
          }
        }
      })
    },
    parsedPrice () {
      const formatter = new Intl.NumberFormat("es-MX");
      return  formatter.format(this.product.price || 0)
    }
  },
  methods: {
    ...mapActions([
      "category/all",
      "delivery/ecommerce",
      "product/all",
      "product/create",
      "product/update",
      "product/destroy",
      "product/assignCategory",
      "product/removeCategory",
      "product/get",
      "helpers/upload_file",
      "variant/all",
      "variant/create",
      'product/images',
      'product/createImage',
      'product/updateImage',
      'product/deleteImage'
    ]),
    getProduct() {
      let self = this;
      this["product/get"]({
        account_id: self.$route.params.account_id,
        product_id: self.$route.params.product_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error);
          } else {
            for (let key in res.resource) {
              this.product[key] = res.resource[key]
            }
            this.product.categories = this.product.Categories.map(c => c.category_id)
          }
        },
      });
    },
    getCategories() {
      let self = this;
      this.loading = true;

      this["category/all"]({
        account_id: self.$route.params.account_id,
        params: {
          relationship : "parent",
        },
        callback: (res) => {
          self.loading = false;
          if (res.error) {
            self.$message.error(res.error);
          }
        },
      });

      this["category/all"]({
        account_id: self.$route.params.account_id,
        soft: true,
        params: {
          limit: 1000,
          page: 1
        },
        callback: (res) => {
          this.allCategories = res.resource || []
        },
      });
    },
    getEcommerceData () {
      let self = this

      this['delivery/ecommerce']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    async createProduct() {
      let self = this;
      this.product.validated = false;
      this.showLoadingScreen()

      if (!this.product.name || !this.isPriceOk || !this.isStockPos) {
        this.product.validated = true;
        return;
      }

      if(this.measures_requiered) {
        let measures = ["weight", "width", "height", "length"]
        for(let key in this.product) {
          if(measures.includes(key) && (!this.product[key] || this.product[key] == '' || this.product[key] <= 0)) {
            this.product.validated = true;
            this.$message.warning("Especifica las medidas del producto");
            if(!$('#advanced-config')[0].className.includes("show"))
              self.$root.$emit('bv::toggle::collapse', 'advanced-config')
            return
          }
        }
      }

      this.loading_product = true;

      if (this.file) {
        try {
          this.image_file = await UploadFile.call(this, this.file);
          this.product.image = this.image_file;
        } catch (e) {
          self.$message.error("Error subiendo imagen");
          this.loading_product = false;
          return;
        }
      }

      this["product/create"]({
        account_id: self.$route.params.account_id,
        ...this.product,
        callback: async (res) => {
          self.loading_product = false;
          if (res.error) {
            self.$message.error(res.error);
          } else {
            self.$message.success("Producto creado correctamente.");

            let created_id = res.resource.product_id;

            let pendingCategories = []

            if (self.pending_categories.length) {
              for (let category_id of self.pending_categories) {
                pendingCategories.push(self.assignCategoryPromise(category_id, created_id))
              }
            }

            await Promise.all(pendingCategories)

            self.hideLoadingScreen()
            // self.$router.push({name: 'Categories', params: { ...self.$route.params, category_id: 'all' } })
            self.variantsOpened = true
            self.$router.push({name: 'Product', params: { product_id: created_id} }).catch(() => {})
          }
        },
      });
    },
    deleteProduct() {
      var self = this;
      this["product/destroy"]({
        account_id: self.$route.params.account_id,
        ...this.product,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error);
          } else {
            self.$message.success("Producto eliminado");
            self.$router.push({name: 'Products'})
          }
        },
      });
    },
    async updateProduct() {
      if (isNaN(this.$route.params.product_id)) {
        return this.createProduct()
      }
      let self = this;
      this.showLoadingScreen()

      this.loading_product = true;

      if (this.file) {
        try {
          this.image_file = await UploadFile.call(this, this.file);
          this.product.image = this.image_file;
        } catch (e) {
          console.log(e);
          self.$message.error("Error subiendo imagen");
          this.loading_product = false;
          this.hideLoadingScreen()
          return;
        }
      }

      this["product/update"]({
        account_id: self.$route.params.account_id,
        ...this.product,
        callback: (res) => {
          this.hideLoadingScreen()
          self.loading_product = false;
          if (res.error) {
            self.$message.error(res.error);
          } else {
            self.$message.success("Producto actualizado");
            setTimeout(() => {
              this.$router.push({name: 'Products'}).catch(() => {})
            }, 700);
          }
        },
      });
    },
    clearImage() {
      this.product.image = "";
      this.file = null;
      this.$refs['upload_image_input'].value = ''
    },
    confirmDeleteProduct() {
      let self = this;

      this.$bvModal
        .msgBoxConfirm(
          `¿Deseas eliminar el producto ${this.product.name}? No se puede deshacer.`,
          {
            title: "Eliminar producto",
            okTitle: "Eliminar",
            okVariant: "danger",
            cancelTitle: "Cancelar",
          }
        )
        .then((value) => {
          if (value == true) {
            self.deleteProduct();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    async imagePicked(event) {
      let file = event.target.files[0];
      this.product.image = URL.createObjectURL(file);
      this.file = file;
    },
    async newImagePicked(event) {
      let file = event.target.files[0];
      if (file) {
        this.image = URL.createObjectURL(file);
        try {
          this.showLoadingScreen()
          this.image = await UploadFile.call(this, file);
          this.createImage(this.image)
          this.hideLoadingScreen()
        } catch (e) {
          console.log(e);
          self.$message.error("Error subiendo imagen");
          this.hideLoadingScreen()
          return;
        }
      }
    },
    async uploadFile(file) {
      let self = this;
      return new Promise(async (resolve, reject) => {
        let params = {
          file_name: file.name,
          mime: file.type,
        };

        try {
          if (file.name.includes("."))
            params.file_extension = file.name.split(".").slice(-1);
        } catch (e) {
          console.log(e.message);
        }

        try {
          let fileBase64 = await toBase64(file, true);
          params.file = fileBase64;
        } catch (e) {
          console.log(e.message);
          reject(new Error("Error cargando archivo"));
        }

        self["helpers/upload_file"]({
          ...params,
          callback: (res) => {
            if (res.error) {
              reject(new Error(res.error));
            } else {
              resolve(res.resource.url);
            }
          },
        });
      });
    },
    changeCategories(category_id) {
      let index = this.current_categories.findIndex((c) => c == category_id);
      if (index >= 0) {
        this.product.product_id
          ? this.removeCategory(category_id, this.product.product_id)
          : this.current_categories.splice(index, 1);
      } else {
        this.product.product_id
          ? this.assignCategory(category_id, this.product.product_id)
          : this.current_categories.push(category_id);
      }
    },
    assignCategory(category_id, product_id, silent) {
      let self = this;
      this.loading_categories = true;

      this["product/assignCategory"]({
        product_id: product_id,
        category_id: category_id,
        callback: (res) => {
          self.loading_categories = false;
          if (res.error) {
            self.$message.error(res.error);
          } else {
            if (!silent) self.product.categories.push(category_id);
          }
        },
      });
    },
    assignCategoryPromise(category_id, product_id) {
      return new Promise((resolve) => {
        this["product/assignCategory"]({
          product_id: product_id,
          category_id: category_id,
          callback: (res) => {
            resolve()
          },
        });
      })
    },
    removeCategory(category_id, product_id) {
      let self = this;
      this.loading_categories = true;

      this["product/removeCategory"]({
        product_id: product_id,
        category_id: category_id,
        callback: (res) => {
          self.loading_categories = false;
          if (res.error) {
            self.$message.error(res.error);
          } else {
            let index = self.product.categories.findIndex(
              (c) => c == category_id
            );
            if (index >= 0) self.product.categories.splice(index, 1);
          }
        },
      });
    },
    goBack () {
      if (this.$route.name == 'Service') {
        this.$router.push({name: 'Services', params: this.$route.params}).catch(() => {});
      } else {
        this.$router.push({name: 'Products', params: this.$route.params}).catch(() => {});
      }
    },
    getVariants () {
      let self = this
      this.loading = true

      this['variant/all']({
        product_id: self.$route.params.product_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            // self.$message.error(res.error)
          }
        }
      })
    },
    createVariant () {
      let self = this
      this.loading = true

      this['variant/create']({
        product_id: self.$route.params.product_id,
        name: '',
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Variante creada')
          }
        }
      })
    },
    getAllProducts() {
      let self = this

      this.showLoadingScreen()
      this['product/all']({
        account_id: self.$route.params.account_id,
        list_all: true,
        callback: res => {
          this.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getCategoryName (id) {
      let cat = this.categories_list.find(c => c.value == id)
      if (cat) {
        return cat.text
      } else {
        return ''
      }
    },
    getImages() {
      let self = this;
      this["product/images"]({
        product_id: self.$route.params.product_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error);
          } else {
            this.images = res.resource
          }
        },
      });
    },
    createImage(image) {
      let self = this;
      this["product/createImage"]({
        product_id: self.$route.params.product_id,
        images: {
          url: image
        },
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error);
          } else {
            this.$message.success('Imagen subida correctamente');
            this.images.push(res.resource[0])
          }
        },
      });
    },
    deleteImage(image) {
      let self = this;
      this["product/deleteImage"]({
        product_id: self.$route.params.product_id,
        image_id: image.image_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error);
          } else {
            self.$message.success('Imagen eliminada con éxito');
            let index = this.images.findIndex(i => i.image_id == image.image_id)
            if (index >= 0) {
              this.images.splice(index, 1)
            }
          }
        },
      });
    },
    numbersOnly (e) {
      const charCode = e.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault()
      }
      return true
    }
  },
  mounted () {
    if (!isNaN(this.$route.params.product_id)) {
      this.getProduct()
      this.getVariants()
      this.getImages()
    }
    this.getEcommerceData()
    this.getCategories()
    this.getAllProducts()
  },
  watch: {
    '$route' (value) {
      if (!isNaN(this.$route.params.product_id)) {
        this.getProduct()
        this.getVariants()
      }
      this.getCategories()
    }
  },
  components: {
    VariantValues,
    ProductVariants,
    KanguroInfo,
    Validators
  }
};
</script>

<style lang="scss">
  .center-in-container {
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 25px);
    z-index: 1;
  }

  .add-image-button {
    width: 150px;
    height: 150px;
    border: 2px dashed #4a5dff;
    border-radius: 5px;

    &:hover {
      color: #4a5dff;
    }
  }
</style>
